<template>
  <div id="jumbotron">
    <div class="container text-center">

      <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/mph/mph_logo.webp" alt="MPH" height="120px" class="mx-auto"/>
      <br><br><br>
      <h4>
        Discover your potential with these free tests! 
      </h4>

      <div id="classes" class="row pt-2 pb-5">
        <!-- ENGLISH TEST -->
        <div class="col-12 col-md-6">
          <div class="year p-4 h-100">
            <div class="d-flex flex-column justify-content-between h-100">
              <div>
                <a class="text-decoration-none" href="https://scholarships2u.com/mph/new?mode=english">
                  <div class="card btn">👉 Click here to start</div>
                  <div class="bg-white rounded p-4 text-center">
                    <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/mph/em-logo.jpg" style="height: 100px;"/>
                    <div class="heading my-3" style="color: #2e1aaf">
                      <strong>ENGLISH TEST</strong>
                      <br><small>(For Ages 13 and below)</small>
                    </div>
                  </div>
                  
                </a>
                <div class="text-start pt-3">
                  <p>
                    Not sure where your child stands in English?
                  </p>
                  <p>
                    Take our free online assessment and receive a <strong>One-page report</strong> outlining strengths and improvement areas.
                  </p>
                </div>
              </div>
              <div class="text-center d-none">
                <a class="btn px-4 py-2 my-4" href="https://scholarships2u.com/mph/new?mode=english">
                  👉 Take English Test Now
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- CAREER TEST -->
        <div class="col-12 col-md-6">
          <div class="year p-4 h-100 text-center">
            <div class="d-flex flex-column justify-content-between h-100">
              <div>
                <a class="text-decoration-none" href="https://scholarships2u.com/mph/new?mode=career">
                  <div class="card btn">👉 Click here to start</div>
                  <div class="rounded p-4 text-center"  style="background-color: #62cdd3;">
                    <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/mph/s2u-icon.jpg" style="height: 100px;"/>
                    <div class="heading text-white my-3">
                      <strong>CAREER TEST</strong>
                      <br><small>(For Ages 10 to 21)</small>
                    </div>
                  </div>
                  
                </a>
                <div class="text-start pt-3">
                  <p>
                    Confused about your child’s future education or career path? 
                  </p>
                  <p>
                    This personality-based test offers <strong>early career direction</strong> and helps students discover where they shine.
                  </p>
                </div>
              </div>
              <div class="text-center d-none">
                <a class="btn px-4 py-2 my-4" href="https://scholarships2u.com/mph/new?mode=career">
                  👉 Start Career Test
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center">
          <a href="https://scholarships2u.com/mph/registration" style="color: #FFD84D; font-weight: 600;">
            👉 Skip the tests and sign up for English Classes now
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="container py-5">
    <h4 class="text-primary text-center">
      🌟 Our Mission
    </h4>
    <div>
      <p>
        In partnership with MPH Bookstores, we are on a mission to transform your bookstore visit into a journey of learning, inspiration, and growth.
      </p>
      <p>
        Alongside nurturing a love for reading, we offer:
      </p>
      <p>
        ✅ Interactive English classes
        <br>✅ Fun learning activities
        <br>✅ Engaging workshops & events
      </p>
      <p>
        Our programmes use 21st-century learning methods — making learning creative, fun, and deeply engaging.
      </p>
    </div>
  </div>

  <div class="bg-f4f3f9 py-5">
    <div class="container">
      <h2 class="text-primary text-center">
        🏫 About Edu Circle Group
      </h2>
      <div>
        <p>
          We are a trusted educational group with over 70 years of combined experience helping students succeed in school, career, and life.
        </p>
        <p>
          Our services include:
        </p>
        <ul>
          <li>🧭 Student counselling & global university placement</li>
          <li>English learning & communication programmes</li>
          <li>💼 Career & soft-skills development</li>
          <li>🌍 Study tours, education fairs & workshops</li>
        </ul>
        <p>
          We believe in nurturing confident, globally-minded learners — one student at a time.
        </p>
        <br>
        <h5>🌐 Learn More About Us</h5>
        <p>
          Visit our platforms to explore courses, scholarships, study abroad opportunities & events:
        </p>
        <ul>
          <li><a href="https://scholarships2u.com">https://scholarships2u.com</a></li>
          <li><a href="https://ukenglishmatters.com">https://ukenglishmatters.com</a></li>
          <li><a href="https://citiworldevents.com">https://citiworldevents.com</a></li>
          <li><a href="https://et-studyabroad.com">https://et-studyabroad.com</a></li>
          <li><a href="https://edumetry.app">https://edumetry.app</a></li>
        </ul>
        <br>
        <h5>🎒 Stay Tuned</h5>
        <p>
          Exclusive learning activities & workshops will be coming soon to <strong>MPH @ TRX</strong>!
        </p>
        <p>
          ✨ Learning should not stop at bookshelves — it should come alive.
          <br>We look forward to inspiring your child’s journey!
        </p>
        <br>
        <h5>📞 Need Assistance?</h5>
        <p>
          Our team is here to help.
          <br>📩 Contact us today for enquiries & counselling support. <strong>+6017 380 7335</strong>
        </p>
      </div>
    </div>
  </div>

  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 mb-5 ps-4">
          <p class="title">
            Assessments
          </p>
          <div>
            <a href="https://scholarships2u.com/mph/new?mode=english">
              English Test
            </a>
          </div>
          <div>
            <a href="https://scholarships2u.com/mph/new?mode=career">
              Career Test
            </a>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-5 mb-5 ps-4 pe-5">
          <p class="title">
            {{ $t('footer.whyUs.title') }}
          </p>
          {{ $t('footer.whyUs.description') }}
        </div>
        <div class="col-12 col-md-3 col-lg-3 mb-5 ps-4">
          <p class="title">
            {{ $t('footer.contact.title') }}
          </p>
  
          No.1-3, 2nd Floor,
          <br>Jalan SS 23/15, Taman SEA,
          <br>47400 Petaling Jaya, Selangor,
          <br>MALAYSIA
          
          <br><br>
          <a href="https://wa.me/+60173807335" target="_blank" alt="Contact us via WhatsApp">
            {{ $t('footer.contact.whatsapp') }}
          </a>
        </div>
      </div>
    </div>
    <div style="height: 20vh"></div>
    <div id="copyright" class="text-center">
      &copy; 2026 English Matters Sdn Bhd (1016133-X)
    </div>
  </footer>
</template>

<script>
export default {
  mounted() {
    // Add meta tag to block crawlers
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
  },
  beforeUnmount() {
    // Clean up when component is destroyed
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.remove();
  }
}
</script>

<style scoped>
body, h1, h2, h3, h4, h5, h6, div, p, a, span {
  font-family: "Montserrat", sans-serif;
}
.navbar-toggler {
  border: none;
}

.navbar-toggler-icon {
  filter: invert(1);
}
.navbar {
  background-color: transparent;
  transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* Navbar after scrolling 30vh */
.navbar.scrolled {
  background-color: #2e1aaf;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.navbar .collapse.show, .navbar .collapsing {
  background-color: #2e1aaf !important;
}
nav a {
  color: white; 
  padding-left: 20px !important;
  padding-right: 20px !important;
}
nav a.router-link-active, a:hover {
  color: #FEB832;
}
ul.dropdown-menu li a.nav-link {
  color: black;
}

.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 2em;
}

#jumbotron {
  background-color: #2e1aaf;
  /* background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png"); */
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 5vh;
  color: white;
  /* height: 55vh; */
}

.container { max-width: 1100px; }
#exam { max-width: 400px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }
h4  { font-size: 2.5em; }

@media (max-width: 600px) {
  #jumbotron h1 { font-size: 3em}
}
@media (max-width: 400px) {
  #jumbotron h1 { font-size: 3em}
}

.bg-f4f3f9 {
  background-color: #F4F3F9;
}

#classes p { font-size: 1.2em; }
#classes .year { border-radius: 15px; }
#classes .year .heading { 
  font-size: 1.5em; 
  font-weight: 400;
}
#classes .row {
  /* max-width: 1200px; */
}
#classes .year .sub-heading { 
  font-size: 1.2em; 
  /* color: #B2Aecc; */
  font-weight: 700;
}
#classes a.btn { 
  color: yellow;
  background-color: #e21c21;
  font-weight: bold;
}
#classes div.card.btn { 
  color: yellow;
  background-color: #e21c21;
  font-weight: bold;
  display: inline-block;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
footer {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/footer.png");
  background-position: right bottom -50px;
  background-repeat: no-repeat;
  color: white;
  padding-top: 5em;
  padding-bottom: 3em;
  background-size: 1600px;
}
footer a {
  text-decoration: none;
  color: white;
}
footer a:hover {
  color: #FEB832;
}
p.title {
  font-weight: bold;
  padding-bottom: 20px;
}
#copyright {
  color: #8276cf;
}
#whatsApp {
  position: fixed;
  bottom: 15px;
  right: 15px;
}
</style>
